export default {"src":"/_next/static/media/QUESTIONNAIRE_ACTIVE_DISABLED_ICON.67cef271.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};